import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MATERIAL_SANITY_CHECKS } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ZuperSplashScreenModule } from '@zuper/services/splash-screen';
import { ZuperMediaWatcherModule } from '@zuper/services/media-watcher';
import { ZuperTailwindConfigModule } from '@zuper/services/tailwind';
import { ZuperUtilsModule } from '@zuper/services/utils';

@NgModule({
    imports  : [
        ZuperMediaWatcherModule,
        ZuperSplashScreenModule,
        ZuperTailwindConfigModule,
        ZuperUtilsModule
    ],
    providers: [
        {
            // Disable 'theme' sanity check
            provide : MATERIAL_SANITY_CHECKS,
            useValue: {
                doctype: true,
                theme  : false,
                version: true
            }
        },
        {
            // Use the 'fill' appearance on Angular Material form fields by default
            provide : MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'fill'
            }
        }
    ]
})
export class ZuperModule
{
    /**
     * Constructor
     */
    constructor(@Optional() @SkipSelf() parentModule?: ZuperModule)
    {
        if ( parentModule )
        {
            throw new Error('ZuperModule has already been loaded. Import this module in the AppModule only!');
        }
    }
}
